import { useContext } from 'react';
import Link from 'next/link';
import { Trans } from 'next-i18next';
import { Modal, ThemeContext } from '@forma/forma-ui-kit';
import ClientWrap from '@/components/ClientWrap';
import { analytics } from '@/helpers/analytics';
import { useRequestCall } from '../RequestCall';
import RequestDemoModal3Form from './RequestDemoModal3Form';

import styles from './request-demo-modal-3.module.css';

const RequestDemoModal3 = ({
  open,
  onClose,
  title = 'Бесплатная настройка + триал на 7 дней',
  description = <>  Оставьте контакты — мы подберём удобное время для демонстрации сервиса.<br />  После встречи бесплатно настроим ваши шаблоны, откроем пробный доступ на 7 дней.</>,
  buttonText = 'Оставить заявку',
  additional = {}
}) => {
  const { lang } = useContext(ThemeContext);
  const { onSubmit, isSuccess, isError, isLoading, reset } = useRequestCall({ lang });

  const handleSubmit = (values) => {
    onSubmit({ ...values, ...additional }).then(success => {
      if (success) {
        analytics.sendRequestForm();
      }
    });
  };

  const closeModal = () => {
    reset();
    onClose();
  };

  return (
    <ClientWrap>
      <Modal
        open={open}
        onClose={closeModal}
        width="100%"
        maxWidth="560px"
        title={!isSuccess && !isError && title}
        viewStyle="no-padding"
        containerClassName={styles.container}
        contentClassName={styles.content}
      >
        <input type="hidden" autoFocus />
        {!(isError || isSuccess) && (
          <div className={styles.subtitle}>
            {description}
          </div>
        )}
        <RequestDemoModal3Form
          onSubmit={handleSubmit}
          isSendSuccess={isSuccess}
          isSendError={isError}
          isSendLoading={isLoading}
          buttonText={buttonText}
          noticeText={
            <Trans
              i18nKey="user_agreement_form_notice"
              components={{
                privacy: <Link href="/privacy" target="_blank" />,
                license: <Link href="/license" target="_blank" />,
                button: buttonText,
              }}
            />
          }
        />
      </Modal>
    </ClientWrap>
  );
};

export default RequestDemoModal3;
